import Nullstack from 'nullstack';
export default function IconCurrencyDirham({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-dirham",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 19h-3.5"
  }), "   ", Nullstack.element("path", {
    d: "M8.599 16.479a1.5 1.5 0 1 0 -1.099 2.521"
  }), "   ", Nullstack.element("path", {
    d: "M7 4v9"
  }), "   ", Nullstack.element("path", {
    d: "M15 13h1.888a1.5 1.5 0 0 0 1.296 -2.256l-2.184 -3.744"
  }), "   ", Nullstack.element("path", {
    d: "M11 13.01v-.01"
  }), " ");
}